var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDeleteBlack = function SvgIconDeleteBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    fillRule: "evenodd",
    d: "M9.167 2.548a1.12 1.12 0 0 0-1.119 1.119v1.118h5.904V3.667a1.12 1.12 0 0 0-1.118-1.119zm6.215 2.237V3.667a2.55 2.55 0 0 0-2.548-2.549H9.167a2.55 2.55 0 0 0-2.549 2.548v1.119H2.75a.715.715 0 1 0 0 1.43h1.118v12.118a2.55 2.55 0 0 0 2.549 2.549h9.167a2.55 2.55 0 0 0 2.548-2.549V6.215h1.118a.715.715 0 0 0 0-1.43zM5.298 6.215v12.118a1.12 1.12 0 0 0 1.119 1.119h9.167a1.12 1.12 0 0 0 1.118-1.119V6.215zm3.869 3.153c.395 0 .715.32.715.715v5.5a.715.715 0 0 1-1.43 0v-5.5c0-.395.32-.715.715-.715m3.667 0c.394 0 .715.32.715.715v5.5a.715.715 0 0 1-1.43 0v-5.5c0-.395.32-.715.715-.715",
    clipRule: "evenodd"
  })));
};
export default SvgIconDeleteBlack;